import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Grid,
  Box,
  MenuItem,
  IconButton,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import dayjs from "dayjs";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const AddUserModal = ({
  open,
  openHandler,
  rowToEdit,
  submitClickHandler,
  assetsList,
  reportsToList,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const roles = [
    { key: "MANAGER", value: "Admin" },
    { key: "DPL", value: "DPL" },
    { key: "USER", value: "User" },
  ];
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };
  const validationSchema = Yup.object({
    isDeleted: Yup.boolean(),
    userId: Yup.number(),
    name: Yup.string().required("Required"),
    employeeId: Yup.string().required("Required"),
    userName: Yup.string().required("Required"),
    designation: Yup.string().required("Required"),
    department: Yup.string().required("Required"),
    track: Yup.string().required("Required"),
    reportsTo: Yup.string().nullable(true),
    dob: Yup.date(),
    doj: Yup.date(),
    emailId: Yup.string().email().required("Required"),
    phoneNumber: Yup.string().required("Required"),
    role: Yup.string().required("Required"),
    active: Yup.boolean(),
    assetNameList: Yup.array(),
  });

  return (
    <Dialog open={open} onClose={openHandler} fullWidth maxWidth="md">
      {" "}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {" "}
        {rowToEdit ? <>Edit User</> : <>Add User</>}{" "}
        <CloseIcon
          onClick={() => openHandler()}
          color="primary"
          sx={{ cursor: "pointer" }}
        />{" "}
      </DialogTitle>
      <DialogContent>
        <Formik
          initialValues={{
            isDeleted: rowToEdit?.isDeleted || false,
            userId: rowToEdit?.userId || "",
            name: rowToEdit?.name || "",

            employeeId: rowToEdit?.employeeId || "",
            userName: rowToEdit?.userName || "",
            designation: rowToEdit?.designation || "",
            department: rowToEdit?.department || "",
            track: rowToEdit?.track || "",
            reportsTo: rowToEdit?.reportsTo || "",
            dob: rowToEdit?.dob,
            doj: rowToEdit?.doj,
            role: rowToEdit?.role || "",
            emailId: rowToEdit?.emailId || "",
            phoneNumber: rowToEdit?.phoneNumber || "",
            active: rowToEdit?.active || true,
            assetNameList: rowToEdit?.assetNameList
              ? rowToEdit.assetNameList.split(",").map(String)
              : [],
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            submitClickHandler(values);
          }}
        >
          {(props) => (
            <Form>
              <Grid container spacing={2} sx={{ p: 1 }}>
                {[
                  { name: "name", label: "Name", type: "input" },
                  { name: "employeeId", label: "Employee Id", type: "input" },
                  { name: "userName", label: "User Name", type: "input" },

                  { name: "designation", label: "Designation", type: "input" },
                  { name: "department", label: "Department", type: "input" },
                  {
                    name: "reportsTo",
                    label: "Reports To",
                    type: "select",
                    dimension: "single",
                  },

                  {
                    name: "track",
                    label: "Track",
                    type: "input",
                  },
                  { name: "doj", label: "Date Of Joining", type: "date" },
                  { name: "dob", label: "Date Of Birth", type: "date" },
                  { name: "role", label: "Role", type: "select" },
                  {
                    name: "emailId",
                    label: "Email Id",
                    type: "input",
                  },

                  {
                    name: "phoneNumber",
                    label: "Phone Number",
                    type: "input",
                  },
                  {
                    name: "active",
                    label: "Is Active",
                    type: "boolean",
                  },
                  {
                    name: "assetNameList",
                    label: "Assets List",
                    type: "select",
                  },
                ].map((field) => (
                  <>
                    {field?.type === "input" ? (
                      <Grid item xs={12} md={6} key={field.name}>
                        <Field name={field.name}>
                          {({ field: formikField, meta }) => (
                            <TextField
                              {...formikField}
                              variant="outlined"
                              size="small"
                              label={field.label}
                              type={
                                field.type === "checkbox" ? "checkbox" : "text"
                              }
                              fullWidth
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                            />
                          )}
                        </Field>
                      </Grid>
                    ) : field.type === "select" ? (
                      field.name === "assetNameList" ? (
                        <Grid item xs={12} md={6}>
                          <Field name={field.name}>
                            {({ field: formikField, meta }) => (
                              <TextField
                                {...formikField}
                                variant="outlined"
                                size="small"
                                label={field.label}
                                SelectProps={{
                                  multiple: true,
                                  renderValue: (selected) =>
                                    selected.join(", "),
                                }}
                                renderValue={(selected) => {
                                  if (selected.length === 0) {
                                    return <em>Placeholder</em>;
                                  }

                                  return selected.join(", ");
                                }}
                                select
                                onChange={(event) => {
                                  props.setFieldValue(
                                    field.name,
                                    event.target.value
                                  );
                                }}
                                fullWidth
                                error={meta.touched && Boolean(meta.error)}
                                helperText={meta.touched && meta.error}
                              >
                                {assetsList?.map((val) => {
                                  return (
                                    <MenuItem
                                      key={val.assetName}
                                      value={val.assetName}
                                    >
                                      {`${val.assetId} : ${val.assetName}`}
                                    </MenuItem>
                                  );
                                })}
                              </TextField>
                            )}
                          </Field>
                        </Grid>
                      ) : field.name === "role" ? (
                        <Grid item xs={12} md={6}>
                          <Field name={field.name}>
                            {({ field: formikField, meta }) => (
                              <TextField
                                {...formikField}
                                variant="outlined"
                                size="small"
                                label={field.label}
                                select
                                onChange={(event) => {
                                  props.setFieldValue(
                                    field.name,
                                    event.target.value
                                  );
                                }}
                                fullWidth
                                error={meta.touched && Boolean(meta.error)}
                                helperText={meta.touched && meta.error}
                              >
                                {roles?.map((val) => {
                                  return (
                                    <MenuItem key={val.key} value={val.key}>
                                      {`${val.value} `}
                                    </MenuItem>
                                  );
                                })}
                              </TextField>
                            )}
                          </Field>
                        </Grid>
                      ) : (
                        <Grid item xs={12} md={6}>
                          <Field name={field.name}>
                            {({ field: formikField, meta }) => (
                              <TextField
                                {...formikField}
                                variant="outlined"
                                size="small"
                                label={field.label}
                                renderValue={(selected) => {
                                  if (selected.length === 0) {
                                    return <em>Placeholder</em>;
                                  }

                                  return selected.join(", ");
                                }}
                                select
                                onChange={(event) => {
                                  props.setFieldValue(
                                    field.name,
                                    event.target.value
                                  );
                                }}
                                fullWidth
                                error={meta.touched && Boolean(meta.error)}
                                helperText={meta.touched && meta.error}
                              >
                                {reportsToList?.map((val) => {
                                  return (
                                    <MenuItem
                                      key={val.userId}
                                      value={val.userId}
                                    >
                                      {`${val.userId} : ${val.name}`}
                                    </MenuItem>
                                  );
                                })}
                              </TextField>
                            )}
                          </Field>
                        </Grid>
                      )
                    ) : field.type === "date" ? (
                      <Grid item xs={12} md={6}></Grid>
                    ) : field.type === "password" ? (
                      <Grid item xs={12} md={6} key={field.name}>
                        <Field name={field.name}>
                          {({ field: formikField, meta }) => (
                            <TextField
                              {...formikField}
                              variant="outlined"
                              size="small"
                              label={field.label}
                              type={showPassword ? "text" : "password"}
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    onMouseUp={handleMouseUpPassword}
                                    edge="end"
                                  >
                                    {showPassword ? (
                                      <VisibilityOff />
                                    ) : (
                                      <Visibility />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              }
                              fullWidth
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                            />
                          )}
                        </Field>
                      </Grid>
                    ) : field.type === "boolean" ? (
                      <Grid item xs={12} md={6} key={field.name}>
                        <Field name={field.name}>
                          {({ field }) => (
                            <Box width="100%">
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={props.values[field.name]}
                                    onChange={(event) =>
                                      props.setFieldValue(
                                        field.name,
                                        event.target.checked
                                      )
                                    }
                                    color="success"
                                  />
                                }
                                label="Is Active"
                                labelPlacement="start"
                              />
                            </Box>
                          )}
                        </Field>
                      </Grid>
                    ) : null}
                  </>
                ))}
              </Grid>

              <DialogActions>
                <Button onClick={openHandler}>Cancel</Button>
                <Button type="submit" variant="contained">
                  {rowToEdit ? "Save" : "Add"}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default AddUserModal;
